import { defineRecipe } from '@chakra-ui/react';
import { Space, TextStyles, Radii, FontWeights, Shadows } from '../../types';

// Tag reads the --badge-* custom properties declared here. `colorPalette.N` doesn't resolve inside a custom
// property, so shades use the explicit var(--udl-colors-color-palette-N) variables colorPalette emits.
export const badgeRecipe = defineRecipe({
  base: {
    // On base, not defaultVariants: the recipe has no colorPalette variant key to select.
    colorPalette: 'gray',
    py: '0.5',
    textTransform: 'initial',
    textStyle: TextStyles.P4,
    fontWeight: FontWeights.SEMIBOLD,
    display: 'inline-flex',
    alignItems: 'center',
    flexGrow: '0',
    w: 'fit-content',
    alignSelf: 'center',
    gap: Space['2XS'],
    bg: 'var(--badge-bg)',
    bgColor: 'var(--badge-bg)',
    color: 'var(--badge-color)',
    ring: '1px',
    ringColor: 'var(--badge-shadow)',
    boxShadow: Shadows['2XS'],
    '& > span:has(.svg-inline--fa)': {
      m: 0,
      color: 'var(--badge-iconColor)',
    },
  },
  variants: {
    round: {
      true: {
        px: Space.XS,
        borderRadius: Radii.FULL,
        '& > span:has(.svg-inline--fa)': {
          '&:first-of-type': { ms: -1 },
          '&:last-child': { me: -1 },
        },
      },
      false: {
        px: Space['2XS'],
        borderRadius: Radii.SM,
        '& > span:has(.svg-inline--fa)': {
          '&:first-of-type': { ms: 0 },
          '&:last-child': { me: 0 },
        },
      },
    },
    variant: {
      subtle: {
        '--badge-bg': 'var(--udl-colors-color-palette-50)',
        '--badge-color': 'var(--udl-colors-color-palette-600)',
        '--badge-iconColor': 'var(--udl-colors-color-palette-500)',
        _dark: {
          '--badge-bg': 'var(--udl-colors-color-palette-800)',
          '--badge-color': 'var(--udl-colors-color-palette-200)',
          '--badge-iconColor': 'var(--udl-colors-color-palette-300)',
        },
      },
      solid: {
        '--badge-bg': 'var(--udl-colors-color-palette-500)',
        '--badge-color': 'var(--udl-colors-white)',
        '--badge-iconColor': 'var(--udl-colors-color-palette-100)',
        _dark: {
          '--badge-bg': 'var(--udl-colors-color-palette-600)',
          '--badge-color': 'var(--udl-colors-color-palette-50)',
          '--badge-iconColor': 'var(--udl-colors-color-palette-100)',
        },
      },
      outline: {
        '--badge-color': 'var(--udl-colors-color-palette-500)',
        '--badge-bg': 'var(--udl-colors-color-palette-25)',
        '--badge-shadow': 'var(--udl-colors-color-palette-200)',
        '--badge-iconColor': 'var(--udl-colors-color-palette-400)',
        _dark: {
          '--badge-color': 'var(--udl-colors-color-palette-300)',
          '--badge-bg': 'var(--udl-colors-color-palette-975)',
          '--badge-shadow': 'var(--udl-colors-color-palette-700)',
          '--badge-iconColor': 'var(--udl-colors-color-palette-400)',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'subtle',
    round: false,
  },
});
